import getPress from '@anghami/neogateway/dist/endpoints/getPress';
import { gateway } from '@helpers/neogateway';
import { useTranslation } from 'next-i18next';
import React from 'react';
import PressCard from '../press-card/press-card';
import styles from './press-container.module.scss';
import { combineCN } from '@helpers/styles.helper';
import mainStyles from '../../../pages/investors/investors.module.scss';
interface IProps {
	count: number;
	type: 'investor' | 'press';
}

export default function PressContainer({ count, type }: IProps) {
	const [section, setSection] = React.useState(null);
	const [page, setPage] = React.useState(0);
	const [moreData, setMoreData] = React.useState(false);
	const { t } = useTranslation();

	React.useEffect(() => {
		gateway
		.callEndpoint(getPress, {
			page: '0',
			count,
			show_investor_articles: Boolean(type === 'investor'),
			show_press_articles: Boolean(type === 'press')
		})
		.then(({ data: res }) => {
			if (res?.sections?.length > 0) {
				let sectionData = res.sections[0].data;
				sectionData = Object.entries(sectionData).map((entry) => entry[1]);
				setSection(sectionData);
				setMoreData(Boolean(res.sections[0]?.moreData));
				setPage(page + 1);
			}
		});
	}, []);

	const loadMore = () => {
		gateway.callEndpoint(getPress, { page: page.toString(), count }).then(({ data: res }) => {
			if (res.sections?.length > 0) {
				let sectionData = res.sections[0].data;
				sectionData = Object.entries(sectionData).map((entry) => entry[1]);
				setSection(section.concat(sectionData));
				setMoreData(Boolean(res.sections[0]?.moreData));
				setPage(page + 1);
			}
		});
	};

	return (
		<div
			id="investors-news"
			className={combineCN(
				styles.main_wrapper,
				mainStyles.main_section_wrapper,
				'd-flex f-column f-center'
			)}
		>
			<h2 className={mainStyles.title}>{t('IR_landing_news')}</h2>
			<div className={styles.press_card_container}>
				{section?.map((card) => {
					return <PressCard key={card.id} data={card} />;
				})}
			</div>
			{moreData && (
				<button type="button" className={styles.load_more_btn} onClick={loadMore}>
					{t('show_more')}
				</button>
			)}
		</div>
	);
}
